export let AdditionRewards;

(function (AdditionRewards) {
  AdditionRewards[AdditionRewards["GAME_PP"] = 2] = "GAME_PP";
  AdditionRewards[AdditionRewards["WHEEL_TICKET"] = 19] = "WHEEL_TICKET";
})(AdditionRewards || (AdditionRewards = {}));